import { GATEWAY_URL } from '../../Helper';
import { useApi } from '../../hooks/useApi';
import { useState, useEffect } from "react";
import { Container, Typography, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Add, DeleteForever } from "@mui/icons-material";
import { v4 as uuidv4 } from 'uuid';

function BeatsContent() {
  const [items, setItems] = useState([]);
  const [createBeatDialogOpen, setCreateBeatDialogOpen] = useState(false);
  const [removeBeatDialogOpen, setRemoveBeatDialogOpen] = useState(false);
  const [selectedBeat, setSelectedBeat] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [newSelectedBeat, setNewSelectedBeat] = useState("");
  const [selectedLang, setSelectedLang] = useState("");
  const [selectedName, setSelectedName] = useState("");

  const api = useApi();

  function getBeats() {
    api.customRequest(GATEWAY_URL + '/getBeats', { method: "GET" }, async (resp) => {
      let data = await resp?.json();
      if (data) setItems(data);
    });
  }

  function postNewBeat() {
    let data = new FormData();
    data.append('guid', uuidv4());
    data.append('audio', selectedFile);
    data.append('type', newSelectedBeat);
    data.append('lang', selectedLang);
    data.append('name', selectedName);

    const requestOptions = {
      method: "POST",
      body: data,
      redirect: "follow"
    };

    api.customRequest(GATEWAY_URL + '/createBeat', requestOptions, async () => {
      setCreateBeatDialogOpen(false);
      getBeats();
    });
  }

  function postRemoveBeat(guid) {
    const requestOptions = {
      method: "DELETE",
      redirect: "follow"
    };

    api.customRequest(GATEWAY_URL + '/deleteBeat/' + guid, requestOptions, async () => {
      setRemoveBeatDialogOpen(false);
      getBeats();
    });
  }

  function getStringForType(type) {
    switch (type) {
      case 'walk_with_coach':
      case 'run_with_coach':
        return "Training mit Trainerin";
      case 'walk_without_coach':
      case 'run_without_coach':
        return "Training ohne Trainerin";
      default:
        return "Unbekannt";
    }
  }

  function getStringForLang(lang) {
    switch (lang) {
      case 'de':
        return "DE - Deutsch";
      case 'en':
        return "EN - Englisch";
      case 'fr':
        return "FR - Französisch";
      default:
        return "Unbekannt";
    }
  }

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'lang',
      headerName: 'Sprache',
      flex: 1,
      valueFormatter: (params) => getStringForLang(params)
    },
    {
      field: 'type',
      headerName: 'Art',
      flex: 1,
      valueFormatter: (params) => getStringForType(params)
    },
    {
      field: 'actions',
      headerName: 'Funktionen',
      flex: 0.5,
      align: 'right',
      headerAlign: 'right',
      renderCell: (params) => (
        <Tooltip title="Beat löschen">
          <IconButton onClick={(e) => {
            e.stopPropagation();
            setSelectedBeat(params.row);
            setRemoveBeatDialogOpen(true);
          }}>
            <DeleteForever />
          </IconButton>
        </Tooltip>
      )
    }
  ];

  useEffect(() => {
    getBeats();
  }, []);

  return (
    <div className="content">
      <Container style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ display: "flex", alignItems: "center", marginTop: '50px', justifyContent: "space-between" }}>
          <Typography fontSize={30}>BEATS</Typography>
          <Tooltip title="Beat hinzufügen">
            <IconButton onClick={() => setCreateBeatDialogOpen(true)}>
              <Add />
            </IconButton>
          </Tooltip>
        </div>

        <div style={{ height: 500, width: '100%' }}>
          <DataGrid
            rows={items.map((item, index) => ({ id: index, ...item }))}
            columns={columns}
            pageSize={5}
            disableSelectionOnClick
          />
        </div>

        <Dialog open={createBeatDialogOpen}>
          <DialogTitle>Beat hinzufügen</DialogTitle>
          <DialogContent style={{ width: "450px" }}>
            <TextField
              label="Name"
              value={selectedName}
              onChange={(e) => setSelectedName(e.target.value)}
              fullWidth
              style={{ marginTop: 10 }}
            />
            <Select
              value={selectedLang}
              onChange={(e) => setSelectedLang(e.target.value)}
              fullWidth
              style={{ marginTop: 10 }}
            >
              <MenuItem value="de">DE - Deutsch</MenuItem>
              <MenuItem value="en">EN - Englisch</MenuItem>
              <MenuItem value="fr">FR - Französisch</MenuItem>
            </Select>
            <Select
              value={newSelectedBeat}
              onChange={(e) => setNewSelectedBeat(e.target.value)}
              fullWidth
              style={{ marginTop: 10 }}
            >
              <MenuItem value="walk_with_coach">Training mit Trainerin</MenuItem>
              <MenuItem value="walk_without_coach">Training ohne Trainerin</MenuItem>
            </Select>
            <input
              type="file"
              accept=".mp3,audio/*"
              style={{ marginTop: 10 }}
              onChange={(e) => setSelectedFile(e.target.files[0])}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setCreateBeatDialogOpen(false)} variant="outlined">ABBRECHEN</Button>
            <Button onClick={postNewBeat} variant="contained">HOCHLADEN</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={removeBeatDialogOpen}>
          <DialogTitle>Beat löschen?</DialogTitle>
          <DialogContent>
            <p>Möchten Sie "{selectedBeat?.name}" wirklich löschen?</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setRemoveBeatDialogOpen(false)} variant="outlined">NEIN</Button>
            <Button onClick={() => postRemoveBeat(selectedBeat._id)} variant="contained">JA</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </div>
  );
}

export default BeatsContent;

